/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Default_Confirmation_LabelInputs */



/**
* | output |
* | --- |
* | "Default approvals" |
*
* @param {Agent_Policy_Default_Confirmation_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_default_confirmation_label = /** @type {((inputs?: Agent_Policy_Default_Confirmation_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Default_Confirmation_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Standard für Freigaben")
	return /** @type {LocalizedString} */ ("Default approvals")
});